export const hasDraftScores = draft => Array.isArray(draft?.hole_scores) && draft.hole_scores.some(score => Number(score) > 0);

export const createScoreDraftId = () => {
  if (globalThis.crypto?.randomUUID) return `draft_${globalThis.crypto.randomUUID().replaceAll('-', '')}`;
  return `draft_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
};

export const scoreDraftPath = draftId => `/scores/draft${draftId ? `?draft_id=${encodeURIComponent(draftId)}` : ''}`;

export const restoreScoreDraft = (draft, course) => {
  if (!hasDraftScores(draft)) throw new Error('There is no saved round to resume.');
  if (draft.hole_scores.length > 18 || draft.hole_scores.some(score => score != null && score !== '' && (!Number.isInteger(Number(score)) || Number(score) < 1 || Number(score) > 30))) {
    throw new Error('This saved round could not be read safely. Your scores have not been changed.');
  }
  const holes = [9, 18].includes(draft.number_of_holes) ? draft.number_of_holes : draft.hole_scores.length === 9 ? 9 : 18;
  const scores = draft.hole_scores.map(score => score == null ? '' : String(score));
  while (scores.length < 18) scores.push('');
  const date = draft.date ? new Date(draft.date) : new Date();
  if (!Number.isFinite(date.getTime())) throw new Error('The saved round date is invalid. Your scores have not been changed.');
  const restoredCourse = course || (draft.course_name || draft.hole_pars?.length ? {
    course_id: draft.course_id, name: draft.course_name, hole_pars: draft.hole_pars || [],
  } : null);
  return { draftId: draft.draft_id || 'legacy', scores, holes, date, course: restoredCourse, courseId: draft.course_id,
    startingNine: draft.starting_nine === 'back' ? 'back' : 'front',
    entryMethod: ['manual', 'voice', 'scan'].includes(draft.entry_method) ? draft.entry_method : 'manual',
    tee: draft.tee_name ? { name: draft.tee_name } : null,
    yardages: draft.hole_yardages || [], handicaps: draft.hole_handicaps || [],
    legacy: !draft.number_of_holes || !draft.starting_nine };
};